import { z } from "zod";
import i18n from "@/i18n";

const createNavitationSchema = z.object({
  title: z
    .string()
    .min(1, { message: i18n.t("validation.navigationTitleRequired") })
    .trim(),
  isSidebar: z.boolean().optional(),
});

type CreateNavigationFormData = z.infer<typeof createNavitationSchema>;

export { createNavitationSchema };
export type { CreateNavigationFormData };
